const question3 = {
    'question': 'Czy aby umówić się na wizytę w Colligo, potrzebne jest skierowanie?',
    'answer': 'Nie, aby umówić wizytę w naszym centrum psychiatrii i psychoterapii nie jest potrzebne skierowanie. Obserwując u dziecka pierwsze niepokojące oznaki należy działać niezwłocznie, aby móc zapobiec pogłębieniu się zaburzeń czy problemów dziecka.',
}

export default question3;